module.exports = __webpack_public_path__ + "static/media/cibdPdf.41a29302.png";